import { HttpResponse } from '@angular/common/http';
import { HttpResponseContentType } from '../../shared/models/http-response-content-type.enum';

export abstract class DecryptResponseService {
    public abstract decryptResponse(url: string, encryptedDataBuffer: Uint8Array, bodyFormat: HttpResponseContentType): Promise<HttpResponse<any>>;
}
